import { createAsyncThunk } from '@reduxjs/toolkit';

import { AnimalService } from '../../services';

export const fetchAnimals = createAsyncThunk('animal/fetchAnimals', async (params, { rejectWithValue }) => {
  try {
    const { data } = await AnimalService.fetchAnimals(params);

    return {
      data,
      sireAry: data?.records
        ?.filter(s => s.sex === 'male')
        .map(x => ({
          value: x.id,
          label: x.identifier + ' (' + x.eartag_management_id + ')'
        })),
      calfAry: data?.records?.map(x => ({
        value: x.id,
        label: x.identifier + ' (' + x.eartag_management_id + ')'
      }))
    };
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to fetch animals');
  }
});

export const fetchDashboardAnimals = createAsyncThunk(
  'animal/fetchDashboardAnimals',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await AnimalService.fetchAnimals(params);

      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch animals');
    }
  }
);

export const fetchAnimal = createAsyncThunk('animal/fetchAnimal', async ({ id, params }, { rejectWithValue }) => {
  try {
    const { data } = await AnimalService.fetchAnimal(id, params);

    return data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to fetch animal');
  }
});

export const fetchAnimalsTags = createAsyncThunk('animal/fetchAnimalsTags', async (params, { rejectWithValue }) => {
  try {
    const { data } = await AnimalService.fetchAnimalsTags(params);

    return data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to fetch animals tags');
  }
});

export const fetchAnimalTags = createAsyncThunk(
  'animal/fetchAnimalTags',
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const { data } = await AnimalService.fetchAnimalTags(id, params);

      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch animal tags');
    }
  }
);

export const fetchStockTypes = createAsyncThunk('animal/fetchStockTypes', async (params, { rejectWithValue }) => {
  try {
    const response = await AnimalService.fetchStockTypes(params);

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to fetch animal stock types');
  }
});

export const updateAnimal = createAsyncThunk('animal/updateAnimal', async ({ id, data }, { rejectWithValue }) => {
  const response = await AnimalService.updateAnimal({ id, data });

  return response?.data;
});

export const deleteManyAnimals = createAsyncThunk('animal/deleteManyAnimals', async (ids, { rejectWithValue }) => {
  try {
    const response = await AnimalService.deleteManyAnimals(ids);

    return response?.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to delete animal(s).');
  }
});
